export const DEFAULT_STYLES = 'default';
export const REBRANDING_STYLES = 'rebranding';

export const getStyles = (isRebrandingEnabled: boolean) =>
    isRebrandingEnabled ? REBRANDING_STYLES : DEFAULT_STYLES;

export const getFooterHeight = () =>
    document.getElementsByClassName('eds-modal__footer')[0]?.scrollHeight || 0;

export const getOrderSummaryHeight = () =>
    document.getElementById('order-summary-container')?.scrollHeight;

export const getIsOrderSummaryBiggerThanScreen = (
    orderSummaryHeight: number,
    footerHeight = 0,
) => {
    // Leaving a margin above the order summary to make sure it is not too close to the top being a modal
    const marginTop = 24;
    return orderSummaryHeight + marginTop > screen.height - footerHeight;
};
